import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { retrievePortalTeamupAccessToken } from '../../api'
import { Redirect, withRouter } from 'react-router-dom'
import { AuthContext } from '../../auth-context'

const Page = styled.div`
  background: #eff0f1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`

const TeamupCallback = (props) => {
  const [retrieved, updateRetrieved] = useState(null)
  const { user, updateUser } = useContext(AuthContext)

  useEffect(() => {
    if (retrieved === null && user) {
      updateRetrieved(false)
      if (props.location.search.indexOf('?') === 0) {
        let code = null
        let state = null
        props.location.search.slice(1).split('&').forEach((p) => {
          const a = p.split('=')
          if (a.length === 2) {
            if (a[0] === 'code') {
              code = a[1]
            } else if (a[0] === 'state') {
              state = a[1]
            }
          }
        })
        if (code !== null && state !== null) {
          retrievePortalTeamupAccessToken(user.id, state, code).then((res) => {
            updateRetrieved(true)
            updateUser(Object.assign({}, user, { teamup_connected: true }))
          })
        }
      }
    }
  }, [retrieved, user, updateUser, props.location.search])
  
  return retrieved ? (
    <Redirect to='/dashboard/overview' />
  ) : (
    <Page>
      Authorizing...
    </Page>
  )
}


export default withRouter(TeamupCallback)
